import { createSlice } from "@reduxjs/toolkit";
import { getFormattedDateTime } from "../../../AllFunctions/formattedDateAndTime";

const initialState = {

  hourlyTable: false,
  dailyTable: false,
  currentDayWithTime: { ...getFormattedDateTime() },
  sunRiseSunSet: {},
  formattedWeather: [],
  hourlyWeatherData: [],
  historicWeatherData: [],
  titleBar: "Dashboard",
  titleAccToWeather: "",
  cloudAccToWeather: "",
  previousPage: "",
  latitude: '23.0225',
  longitude: '72.5714',
  myIndex: 0,
  placeName: "",
  geoLocationOn: false,
  locationInput: '',
  suggestions: [],
  loading: false,
  error: null,
  mappedNewLocations: [],
  isModalOpen: false,
  isCelsius: false,
  previousPath: null,
  highlightedIndex: null,
  timeOfDay: "evening",
  hamburger: false,
  theme: "dark"
  // theme : localStorage.getItem("theme") || "light"
};

export const dashboardSlice = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {
    setHourlyTable(state, actions) {
      state.hourlyTable = actions.payload;
    },
    setDailyTable(state, actions) {
      state.dailyTable = actions.payload;
    },
    setCurrentDayWithTime(state, actions) {
      state.currentDayWithTime = actions.payload;
    },
    setSunRiseSunSet(state, actions) {
      state.sunRiseSunSet = actions.payload;
    },
    setTitleBar(state, actions) {
      state.titleBar = actions.payload;
    },
    setTitleAccToWeather(state, actions) {
      state.titleAccToWeather = actions.payload;
    },
    setCloudAccToWeather(state, actions) {
      state.cloudAccToWeather = actions.payload;
    },
    setFormattedWeather(state, actions) {
      state.formattedWeather = actions.payload;
    },
    setHistoricWeatherData(state, actions) {
      state.historicWeatherData = actions.payload;
    },
    setHourlyWeatherData(state, actions) {
      state.hourlyWeatherData = actions.payload;
    },
    setPreviousPage(state, actions) {
      state.previousPage = actions.payload;
    },
    setLongitude(state, actions) {
      console.log('Setting longitude from', state.longitude, 'to', actions.payload);
      state.longitude = actions.payload;
    },
    setLatitude(state, actions) {
      console.log('Setting latitude from', state.latitude, 'to', actions.payload);
      state.latitude = actions.payload;
    },
    setMyIndex(state, actions) {
      state.myIndex = actions.payload;
    },
    setPlaceName(state, actions) {
      state.placeName = actions.payload;
    },
    setGeoLocationOn(state, actions) {
      state.geoLocationOn = actions.payload;
    },
    setLocationInput(state, actions) {
      state.locationInput = actions.payload;
    },
    setSuggestions(state, actions) {
      state.suggestions = actions.payload;
    },
    setLoading(state, actions) {
      state.loading = actions.payload;
    },
    setError(state, actions) {
      state.error = actions.payload;
    },
    setMappedNewLocations(state, actions) {
      state.mappedNewLocations = actions.payload;
    },
    setIsModalOpen(state, actions) {
      state.isModalOpen = actions.payload;
    },
    setIsCelsius(state, actions) {
      state.isCelsius = actions.payload;
    },
    setPreviousPath(state, actions) {
      state.previousPath = actions.payload;
    },
    setHighlightedIndex(state, actions) {
      state.highlightedIndex = actions.payload;
    },
    setTimeOfDay(state, actions) {
      state.timeOfDay = actions.payload;
    },
    setHamburger(state, actions) {
      state.hamburger = actions.payload;
    },
    setTheme(state, action) {
      state.theme = action.payload;
      // localStorage.setItem("theme", action.payload); // Persist theme to localStorage
    },

  },
});

// Action creators are generated for each case reducer function
export const { setHourlyTable, setDailyTable, setCurrentDayWithTime, setSunRiseSunSet, setTitleBar, setTitleAccToWeather, setCloudAccToWeather, setFormattedWeather, setHistoricWeatherData, setPreviousPage, setLongitude, setLatitude, setHourlyWeatherData, setMyIndex, setPlaceName, setGeoLocationOn, setLocationInput, setSuggestions, setLoading, setError, setMappedNewLocations, setIsModalOpen, setPreviousPath, setHighlightedIndex, setTimeOfDay, setHamburger, setTheme, setIsCelsius } = dashboardSlice.actions;

export default dashboardSlice.reducer;
